/**
 * BannerAdSlot — Leaderboard-format (728×90 / full-bleed) advertising slot.
 *
 * Placeholder state: shows banner-ad.png darkened with an "Advertise with us"
 * overlay and a mailto: CTA. When a real advertiser is onboarded, swap:
 *   - Remove <div className="ss-banner-ad-overlay"> entirely
 *   - Wrap the <img> in an <a href="..."> pointing to advertiser URL
 *   - Remove the brightness filter
 *   - Optionally drive from Firestore ad_config doc for no-redeploy updates
 */

import React from 'react';
import './BannerAdSlot.css';

export default function BannerAdSlot({ onContactClick }) {
  return (
    <div className="ss-banner-ad-slot">
      <div className="ss-banner-ad-wrapper">
        <img
          src="/banner-ad.png"
          alt="Advertisement"
          className="ss-banner-ad-img"
        />

        {/* "Advertise with us" overlay — remove when real advertiser is live */}
        <div className="ss-banner-ad-overlay">
          <div className="ss-banner-ad-overlay-content">
            <span className="ss-banner-ad-eyebrow">📢 ADVERTISE WITH US</span>
            <p className="ss-banner-ad-message">This banner could be yours.</p>
            <button
              className="ss-banner-ad-cta"
              onClick={onContactClick}
            >
              GET IN TOUCH →
            </button>
          </div>
        </div>
      </div>

      <div className="ss-banner-ad-label">Advertisement</div>
    </div>
  );
}
